import { useTranslation } from "react-i18next";
import { Modal } from "../../common";
import { Button } from "../../App.styles";

const TitleModal = ({ onDismiss, show }) => {
    const { t } = useTranslation();

    return (
        <Modal onDismiss={onDismiss} show={show}>
            <div className="modal-header">
                <h4 className="modal-title" dangerouslySetInnerHTML={{ __html: t(`NPC Name`) }} />
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onClick={onDismiss}
                >
                    ×
                </button>
            </div>
            <div className="modal-body">
                <p dangerouslySetInnerHTML={{
                    __html: t(`The name you give your NPC will be shown in the chat room when the NPC messages within the game chat. 
        In order for players to engage with this NPC they will need to address them by this name.`)
                }} />
                <ul>
                    <li dangerouslySetInnerHTML={{
                        __html: t(`Players address the NPC by saying "Hey Paul blah blah" or "Paul, blah blah" etc.`)
                    }} />
                    <li dangerouslySetInnerHTML={{
                        __html: t(`Good NPC names are short.`)
                    }} />
                    <li dangerouslySetInnerHTML={{
                        __html: t(`NPC names can be handed out to players in challenge descriptions, reward descriptions, or even by chat.`)
                    }} />
                    <li dangerouslySetInnerHTML={{
                        __html: t(`When you delete an NPC, all their messages in chat are also deleted.`)
                    }} />
                    <li dangerouslySetInnerHTML={{
                        __html: t(`When you update an NPC description, all their messages in chat are also deleted as we consider that a brain-swap. 
                Use this to clear preview messages when satisfied with your configuration.`)
                    }} />
                </ul>
            </div>
            <div className="modal-footer">
                <Button type="button" color="dark" data-dismiss="modal" onClick={onDismiss}>
                    {t(`Close`)}
                </Button>
            </div>
        </Modal>
    )
};

export default TitleModal;
